module.exports = __webpack_public_path__ + "static/media/arrow-down.d7590a4e.svg";